import React from 'react';

const ChatHeader = ({ isMinimized, setIsMinimized }) => {
  return (
    <div className="chat-header">
      <div className="d-flex align-items-center">
        <div className="chat-avatar me-3">
          <i className="fas fa-brain"></i>
        </div>
        <div>
          <h5 className="mb-0 text-white">Ivo's Assistent</h5>
          <small className="text-light opacity-75">
            <i className="fas fa-circle text-success me-1" style={{fontSize: '8px'}}></i>
            Nimm mit mir Kontakt auf (Chat wird weitergeleitet)
          </small>
        </div>
      </div>
      <button 
        className="btn btn-link text-white p-0"
        onClick={() => setIsMinimized(!isMinimized)}
      >
        <i className={`fas fa-${isMinimized ? 'expand' : 'minus'}`}></i>
      </button>
    </div>
  );
};

export default ChatHeader;
